import React from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locales';
import { ContentLanguage } from '@/domains';
import { RemoteConfigKey } from '@/services/remote-config';

import { TenantContainer } from '@/containers/TenantContainer';
import { SessionContainer } from '@/containers/SessionContainer';

import { LanguageListItem } from './LanguageListItem';
import { BackToViewButton } from './BackToViewButton';

export interface Props {
  onBack: () => void;
}

export const LessonsLanguageSelectionView: React.FC<Props> = ({ onBack }) => {
  const { config } = TenantContainer.useContainer();
  const { preferences, updatePreferences } = SessionContainer.useContainer();

  const languages = config[RemoteConfigKey.LessonLanguages];

  const options: { value: ContentLanguage; text: string }[] = React.useMemo(
    () => [
      ...languages.map((language) => ({
        value: language,
        text: translations.i18n.languages[language]
      })),
      { value: 'auto', text: translations.misc.auto }
    ],
    [languages]
  );

  const setUserLessonsLanguage = React.useCallback(
    (contentLanguage: ContentLanguage) => updatePreferences({ contentLanguage }),
    [updatePreferences]
  );

  return (
    <div>
      <BackToViewButton onClick={onBack}>
        <FormattedMessage id={translations.misc.mainMenu} />
      </BackToViewButton>

      <ul>
        {options.map(({ value, text }) => (
          <LanguageListItem
            key={value}
            selected={preferences.contentLanguage === value}
            onClick={() => setUserLessonsLanguage(value)}
          >
            <FormattedMessage id={text} />
          </LanguageListItem>
        ))}
      </ul>
    </div>
  );
};
